import type * as z from "zod";

/** Names a field of `schema`, so prose that cites it breaks the build on a rename. */
export function schemaKey<T>(
  _schema: z.ZodType<T>,
  key: keyof T & string,
): string {
  return key;
}
